<template>
<div>
  <div class="row">
    <div class="col-sm-12 col-md-12 breadcrumb-side-button">
      <div class="float-md-right mb-3">
        <el-tooltip
          placement="top"
          :effect="themeMode.darkMode == true ? 'light' : 'dark'"
          :content="$t('instruction')">
            <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="instructionOpen">
            <!-- {{ $t("instruction") }} -->
            <app-icon name="book-open" />
          </button>
        </el-tooltip>
        <el-tooltip
          placement="top"
          :effect="themeMode.darkMode == true ? 'light' : 'dark'"
          :content="$t('print_detail')">
          <button
            type="button" 
            @click.prevent="generateReport" 
            class="btn btn-primary btn-sm">Print</button>
        </el-tooltip>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
      <div class="alert alert-info" role="alert">
        <button type="button" class="close" @click.prevent="instructionClose">
          <h5 aria-hidden="true">&times;</h5>
        </button>
        <!-- <hr> -->
        <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_site_task") }}</h5>
        <p class="mb-0">{{ $t("introduction_site_task") }}</p>
        <strong>Actions:</strong>
        <ul>
          <li v-if="userRole.role == 'Supplier' || $attrs['props'].type == 'private'"><strong>{{ $t("edit") }} :</strong> {{ $t("edit_task_detail") }}</li>
          <li><strong>{{ $t("view") }} :</strong> {{ $t("view_task_detail") }}</li>
          <li v-if="userRole.role == 'Supplier' || $attrs['props'].type == 'private'"><strong>{{ $t("reminder") }} :</strong> {{ $t("reminder_task_detail") }}</li>
        </ul>
      </div>
    </div>
  </div>
    <!-- <div class="float-md-right mb-5" v-if="this.active == 1">
        <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="generateReport">
                {{ $t("print") }}
        </button>
    </div> -->
    <div v-if="this.active != 1" class="mb-2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 4"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
        <el-breadcrumb-item v-if="this.active == 2">Task Detail</el-breadcrumb-item>
        <el-breadcrumb-item v-if="this.active == 3">Task Edit</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <el-form v-if="active === 1">
        <VueHtml2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="myPDF"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-content-width="100%"
          ref="html2Pdf">
            <section slot="pdf-content">
                <app-table :id="tableId" :options="options" @action="getListAction"/>
            </section>
        </VueHtml2pdf>
    </el-form> 
    <el-form v-if="active === 2">
        <task-mytask-view :id="task_id" :remove="classRemove" :active="{ active }"></task-mytask-view>
    </el-form>
    <el-form v-if="active === 3">
        <mysite-task-edit :id="task_id" :active="{ active }" :back="previous"></mysite-task-edit>
    </el-form>
    <task-reminder
      v-if="isTaskReminderModalActive"
      :bgStyle="bgStyle"
      modal-id="reminder-Modal"
      :taskId="task_id"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskReminderModalActive = false"
    />
</div>
</template>
    

<script>

import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import { SITE_INFORMATION_TASK, GET_SITE_USER_ASSIGNED_LIST } from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";

export default {
    extends: CoreLibrary,
    mixins: [TableHelpers],
  data() {
    return {
      instructionShow: false,
      bgStyle: true,
      isTaskReminderModalActive: false,
      classRemove: true,
      active: 1,
      siteId: this.$attrs['props'].id,
      task_id: 0,
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: this.$attrs['props'].url ?? SITE_INFORMATION_TASK,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
            {
                title: this.$t("task"),
                type: "custom-html",
                key: "title",
                modifier: (value) => {
                return `<span>${this.$t(value)}</span>`;
                },
            },
            {
                title: this.$t("assigned_to"),
                type: "component",
                key: "users",
                isVisible: true,
                className: "w-100",
                componentName: "group-of-users",
            },
            {
                title: this.$t("start_date_&_time"),
                type: "custom-html",
                key: "start_date",
                modifier: (value, row) => {
                let start_time = moment(row.start_time, ["h:mm"]).format("h:mm A");
                return `<span>${this.$t(value)}</span><br><span>${this.$t(start_time)}</span>`;
                },
            },
            {
                title: this.$t("due_date_&_time"),
                type: "custom-html",
                key: "due_date",
                modifier: (value, row) => {
                let end_time = moment(row.end_time, ["h:mm"]).format("h:mm A");
                return `<span>${this.$t(value)}</span><br><span>${this.$t(end_time)}</span>`;
                },
            },
            {
                title: this.$t("status"),
                type: "custom-html",
                key: "status",
                isVisible: true,
                modifier: (value) => {
                let ClassName = "danger";

                if (value === "completed") ClassName = `success`;
                else if (value === "incomplete") ClassName = `warning`;
                else if (value === "action_required") {
                    ClassName = `info`; value = 'Action Required';}

                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                    value
                )}</span>`;
                },
            }
        
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
            {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 5,
        showAction: true,
        orderBy: "asc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  computed: {
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
      themeMode() {
        return this.$store.state.theme;
      },
   },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
      generateReport() {
        this.$refs.html2Pdf.generatePdf();
    },
      getListAction(rowData, actionObj, active) {
        this.$store.commit('updateSharedData', {index: "taskData", newValue: rowData})
        this.$store.commit('updateSharedData', {index: "taskId", newValue: rowData.id})


        if (actionObj.title == this.$t("edit")) {
            this.task_id = rowData.id;
            this.active = 3;
      } else if (actionObj.title == this.$t("view")) {
            this.task_id = rowData.id;
            this.active = 2;
      } else if (actionObj.title == this.$t('reminder')){
        this.openReminderModal(rowData.id);
      }
    },
     openReminderModal(task_id){
      this.isTaskReminderModalActive = true;
      this.task_id = task_id;
    },
    previous() {
      this.active = 1;
    },
    searchAndSelectFilterOptions() {
      axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.siteId).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
  },
  mounted() {
      this.options.url = this.$attrs['props'].url != null ? this.$attrs['props'].url + '/' + this.siteId : SITE_INFORMATION_TASK + '/' + this.siteId;
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");

        if (this.userRole.role == 'Supplier' || this.$attrs['props'].type == 'private') {
            this.options.actions = [
                {
                    title: this.$t("edit"),
                    icon: "edit",
                    type: "none",

                },
                {
                    title: this.$t("view"),
                    icon: "eye",
                    type: "none",
                },
                {
                    title: this.$t("reminder"),
                    icon: "eye",
                    type: "none",
                },
          ]
        }
  },
};
</script>
